import React from 'react';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import RangeSlider from 'components/formElements/RangeSlider';
import RadioButton from 'components/formElements/RadioButton';
import Label from 'components/formElements/Label';
import Tooltip from 'components/formElements/Tooltip';

import iconCheckmark from 'assets/images/icon_circle_checkmark_grey.svg';
import iconCross from 'assets/images/icon_circle_cross.svg';

const EnergyCost = () => {
    return (
        <Stack gap={4} className="ContainerPaddingSmall">
            <h1 className="text-center">Ihren Stromspeicher konfigurieren</h1>
            <div className="text-center">Bitte geben Sie Ihre Stromkosten an. <Tooltip label="Statistischer Durchschnitt aus 2023." /></div>
            <RangeSlider name="Energycost" label="Stromkosten pro kWh in Cent" unit="Cent" default="30" max="80" min="10"  />
            <RangeSlider name="EnergycostTwentyYearIncrease" label="Erwartete Stromkostensteigerung in Prozent/Jahr der nächsten 20 Jahre" unit="%" default="3" max="10" min="0" step="0.1"  />
            <RangeSlider name="EnergyCompensation" label="Stromvergütung pro kWh in Cent" unit="Cent" default="8.6" max="50" min="1" step="0.1" />
            <Label text="Notstrom gewünscht?" />
            <Stack gap={3} direction="horizontal">
                <RadioButton name="EmergencyPower" label="Ja" image={iconCheckmark} />
                <RadioButton name="EmergencyPower" label="Nein" image={iconCross} />
            </Stack>
            <Stack gap={3} direction="horizontal" className="mt-4 flex-column flex-md-row button-group align-items-start">
                <Link className="order-1 order-md-0 btn-previous" to="/EnergyConsumption"><Button variant="outline-light">Zurück</Button></Link>
                <Link className="order-0 order-md-1 btn-next" to="/Contact"><Button variant="success">Weiter zum nächsten Schritt</Button></Link>
            </Stack>
        </Stack>
    )
}

export default EnergyCost;